Customer.Tabs ||= {}

class Customer.Tabs.SimpleContainerView extends Backbone.View # implements ContainerView

  # This implementation keeps the inactive views' elements in the DOM.

  initialize: (@options = {}) ->
    @activeView = @options.activeView || throw new Error('Cannot instantiate a ContainerView without an activeView')
    @allViewsById = {}
    @_storeView(@activeView)

  render: ->
    @$el.html(@_activeViewEl())
    @$el.children().attr('data-uniqueid', @activeView.uniqueId())
    @

  setActiveView: (view) ->
    return if view.uniqueId() == @activeView.uniqueId()
    @activeView = view
    viewToActivate = @allViewsById[view.uniqueId()]
    if viewToActivate
      @$el.children().hide()
      @$el.children('*[data-uniqueid="' + view.uniqueId() + '"]').show()
    else
      @allViewsById[view.uniqueId()] = view
      newElement = view.render().el
      $(newElement).attr('data-uniqueid', view.uniqueId())
      @$el.children().hide()
      @$el.append(newElement)

  discardView: (view) ->
    viewToDiscard = @allViewsById[view.uniqueId()]
    if viewToDiscard
      @$el.children('*[data-uniqueid="' + view.uniqueId() + '"]').remove()

  _storeView: (view) ->
    @allViewsById[view.uniqueId()] = view

  _activeViewEl: ->
    @activeView.render().el
